import React from "react";
import PropTypes from "prop-types";

// import DarkLine from "assets/img/Group 153.svg";

import "./main-hero.styles.scss";

const MainHero = (props) => {
  const { heroName, heroDescription, heroTitle } = props;

  return (
    <div className="main-hero">
      <div className="container">
        <div className="main-hero_main">
          <p className="m-0 p-0 text-muted">{heroName}</p>
          <span>{heroDescription}</span>
          {/* <img src={DarkLine} alt="darkline"></img> */}
        </div>
      </div>
      <div className="main-hero_crumble">
        <div className="container p-3">
          HOME <span className="mx-2">/</span> {heroTitle}
        </div>
      </div>
    </div>
  );
};

MainHero.propTypes = {
  heroName: PropTypes.string,
  heroDescription: PropTypes.string,
  heroTitle: PropTypes.string,
};

export default MainHero;
